import { merge } from "lodash";

import { LISTING_STATUS_CODE } from "../../../components/common/const";

import common from "./common";

export default merge(common, {
  editListing: {
    steps: {
      listingDetails: {
        step: "Listing details",
        title: "Start listing your property",
      },
      location: {
        step: "Location",
        title: "Where is your property?",
      },
      locationV2: {
        step: "Location",
        title: "Where is your property?",
      },
      propertyDetails: {
        step: "Property details",
        title: "Give details about your property",
      },
      propertyDetailsV2: {
        step: "Property details",
        title: "Give details about your property",
      },
      descriptionAndMedia: {
        step: "Description & Media",
        title: "What is your property like?",
      },
      upgradeAndReview: {
        step: "Upgrade & Publish",
        title: "Upgrade & Publish",
      },
    },
    listingDetails: {
      saveButton: "Save changes",
      title: "Start listing your property",
    },
    location: {
      saveButton: "Save changes",
      title: "Where is your property?",
    },
    propertyDetails: {
      saveButton: "Save changes",
      title: "Give details about your property",
    },
    descriptionAndMedia: {
      saveButton: "Save changes",
      title: "What is your property like?",
    },
    upgradeAndReview: {
      saveButton: `{status, plural, =${LISTING_STATUS_CODE.EXPIRED} {Reactivate} =${LISTING_STATUS_CODE.OFFLINE} {Reactivate} other {Confirm upgrade}}`,
      title: "Select a tier to upgrade",
      totalDeductions: {
        title: "Total deductions",
        useInfo:
          "{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}",
        remaining:
          'Balance: <span class="remaining-value">{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</span>',
        balance: "Balance:",
        remainingShort:
          '<span class="remaining-value">{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}</span>',
      },
      modal: {
        titleV1: "Are you sure you want to upgrade?",
        content:
          "Upgrading will require <strong>one {isCreditFlattening, select, true {Ad} other {Listing}} credit</strong> to extend the expiry date of your listing.",
        contentNeedCreditV1:
          "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits</strong>.",
        contentNeedCreditAndListingV1:
          "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits</strong>, and upgrading will require <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong> to extend the expiry date of your listing.",
        contentAutoUpgradeNeedCreditV1:
          "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits</strong> and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}.",
        contentAutoUpgradeNeedCreditAndListingV1:
          "Go {listingProductName} will require <strong>{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits</strong> and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}, and upgrading will require <strong>{listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}}</strong> to extend the expiry date of your listing.",
        cancel: "Cancel",
        confirm: "Confirm",

        title: "Confirm upgrade listing?",
        subtitle: "Upgrade summary:",

        contentNeedCredit:
          "Go {listingProductName} will require {credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits.",
        contentNeedCreditAndListing:
          "Go {listingProductName} will require {credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits, and upgrading will require {listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}} to extend the expiry date of your listing.",
        contentAutoUpgradeNeedCredit:
          "Go {listingProductName} will require {credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}.",
        contentAutoUpgradeNeedCreditAndListing:
          "Go {listingProductName} will require {credits} {isCreditFlattening, select, true {Ad} other {Featured}} credits and will be renewed every {productDuration}th day until cancel. The next upgrade renewal is on {nextUpgradeDate}, and upgrading will require {listing} {isCreditFlattening, select, true {Ad} other {Listing}} credit{listing, plural, =0 {} =1 {} other{s}} to extend the expiry date of your listing.",
        cancelV1: "Cancel",
      },
      upgradeSummary: {
        title: "Upgrade to {listingProductName} Listing",
        duration: "({productDuration} days)",
        creditInfo:
          "{credits} {isCreditFlattening, select, true {Ad} other {Featured}} credit{credits, plural, =0 {} =1 {} other{s}}",
        discountTitle: "Discount ({percentage}%)",
        premiumPlusTitle: "Premium Plus",
        totalDeductions: "Total deductions",
        balance: "Balance:",
      },
    },
    crossListing: {
      modal: {
        title:
          "<span style='padding-left: 3px'>Do you want to update listing changes on PropertyGuru?</span>",
        content:
          "You can choose to update your listing changes either on iProperty Pro only or on both platforms.",
        confirm: "Yes, update on both",
        cancel: "Nope, just here",
      },
    },
  },
  overview: {
    common: {
      buttons: {
        edit: "Edit",
        showMore: "View other languages",
        hideMore: "Hide other languages",
        upgrade: "Upgrade",
        readvertise: "Readvertise",
        backToListings: "Back to listings",
        backToOverview: "Back to overview",
        backTop: "Back to the top",
        preview: "Preview",
        copy: "Copy",
        share: "Share",
        offline: "Take offline",
        delete: "Delete listing",
        cancel: "Cancel",
        extend: "Extend expiry",
        degrade: "Degrade to last",
        revertDegrade: "Revive to tier",
        cancelAutoUpgrade: "Cancel auto-upgrade",
        downloadPdf: "Download",
      },
      message: {
        success: {
          readvertise: "The listing has been readvertised.",
        },
        error: {
          readvertise:
            "Failed to readvertise. Your listing is not readvertised.",
        },
      },
    },
    action: {
      migrateListing: {
        withinGracePeriod: {
          title: "Please update your listing",
          content:
            "New mandatory information is required to be filled before the 90 days grace period. To avoid listing updates suspended, please ",
          link: "update your listing now.",
        },
        passGracePeriod: {
          title: "Listing updates are now suspended",
          content:
            "This listing can't be updated due to missing information. Fill in the mandatory fields to continue listing updates. ",
          link: "Update now",
        },
      },
    },
    tier: {
      upgradedDate: "Upgraded on",
      expiresDate: "Upgrade expires in",
      rotation: "Next rotation",
      status: "Listing status:",
      today: "Today",
      unit: "days, ",
      days: "days, ",
      postedDate: "Posted date",
      actionDate: {
        "2": "Listed on",
        "3": "Offline on",
        "5": "Expire on",
      },
      updateDate: "Last updated on",
      id: "IPP ID:",
      pgId: "PG ID:",
      agentName: "Agent name:",
      expires: "Listing expires in",
      agentLicense: "Agent license:",
      readvertise: "Readvertise:",
    },
    summary: {
      title: "Listing details",
      listingType: "Listing type:",
      category: "Category type:",
      exclusivity: "Exclusivity:",
      groupType: "Property group type:",
      storey: "Storey:",
      auction: "Auction details:",
      coAgency: "Co-agency listing:",
      isCoAgency: "{isCoAgency, plural, =1 {Yes} other {No}}",
      agentName: "Agent name:",
      referenceNum: "Reference number:",
      address: "Address:",
    },
    propertyDetail: {
      price: {
        buy: "Sale price:",
        rent: "Rental:",
        perBuilt: "Built-up per {unit}:",
        perLand: "Land area per {unit}:",
        maintenance: "Maintenance fee:",
      },
      sizeDetails: {
        saleable: "Built-up area ({unit}):",
        gross: "Land area ({unit}):",
        dimension: "{width} x {length}",
      },
      configuration: {
        bed: "Bedrooms:",
        bath: "Bathrooms:",
        maid: "Maid rooms:",
        carpark: "Carparks:",
      },
      other: {
        title: "Tenure, Title and Occupancy",
        tenure: "Tenure:",
        titleType: "Title type:",
        landTitleType: "Land title type:",
        occupancy: "Occupancy status:",
        bumiLot: {
          label: "Bumi Lot:",
          value: "{value, plural, =1 {Yes} other {No}}",
        },
      },
      additional: {
        title: "Additional details",
        unexpired: "Unexpired lease year:",
        unitType: "Unit type:",
        direction: "Property direction:",
        furnishings: "Furnishing:",
        availability: "Availability date:",
        v3: {
          unexpired: "Lease year remaining:",
          unitType: "Property unit type:",
          availableImmediately: "Immediately",
        },
      },
      features: {
        title: "Property highlights and features",
      },
      facilities: {
        title: "Building facilities",
        titleV3: "Property facilities",
      },
    },
    title: {
      title: "Headline",
    },
    description: {
      title: "Description & Media",
      description: {
        legend: "Description",
        english: "In English",
        malaysia: "In Bahasa Malaysia",
        legends: {
          en_GB: "In English",
          ms_MY: "In Bahasa Malaysia",
        },
      },
      media: {
        legend: "Media",
      },
      disclaimer: {
        description:
          "Please note listings are subject to review post submission in accordance with our ",
        link: "Acceptable Use Policy.",
      },
    },
    liveTour: {
      title: "Live Tour",
      value:
        "{value, plural, =1 {Yes, I’m available for live viewing via video call} other {No, I’m not available}}",
    },
    tenancyRule: {
      title: "Tenancy rules",
      maximumTenant: {
        label: "Maximum no. of tenants:",
      },
      allowedTenantGender: {
        label: "Allowed tenant gender(s):",
      },
      isOwnerStaying: {
        label: "Is the owner staying in the unit:",
        value: "{value, select, true {Yes} false {No} other {-}}",
      },
      cookingRule: {
        label: "Cooking rule:",
      },
      isPetAllowed: {
        label: "Are pets allowed:",
        value: "{value, select, true {Yes} false {No} other {-}}",
      },
      isWifiIncluded: {
        label: "Is wifi included:",
        value: "{value, select, true {Yes} false {No} other {-}}",
      },
      isUtilityIncluded: {
        label: "Are utilities included:",
        value: "{value, select, true {Yes} false {No} other {-}}",
      },
      isVisitorAllowed: {
        label: "Are visitor allowed:",
        value: "{value, select, true {Yes} false {No} other {-}}",
      },
    },
    tenure: {
      title: "Tenure and title",
    },
    unitDetails: {
      title: "Unit features",
    },
    share: {
      title: "Share",
      modalTitle: "Share listing",
      type: {
        "facebook-square": "Facebook",
        whatsapp: "Whatsapp",
        "linkedin-square": "Linkedin",
        twitter: "Twitter",
        "link-lg": "Copy link",
        email: "Email",
      },
    },
    tooltip: {
      posted: "The date the listing moves to the top of the tier.",
      rotation:
        "The next date this listing will be moved back at the top of premium.",
      upgradedDate: "The date this listing was upgraded.",
      expiresDate: "The date this upgrade will be expired.",
      updateDate: "The last date this listing's details were edited.",
      expires: "The date the listing expires.",
      listed: {
        [LISTING_STATUS_CODE.ONLINE]:
          "The most recent date the listing went online.",
        [LISTING_STATUS_CODE.EXPIRED]: "The date the listing expires.",
        [LISTING_STATUS_CODE.OFFLINE]:
          "The most recent date the listing was switched to offline.",
      },
    },
    dataHook: {
      belowAvgImpressionPrefix: "Performance: ",
      belowAvgImpressionPrefixShort: "Perf: ",
      belowAvgImpression:
        '<span class="percentage">{percentage}% below avg.</span>',
      belowAvgImpressionTooltip: {
        percentageText:
          "Your listing has {percentage}% lower impressions compared to other listings in the city.",
        upgradeText: "Upgrade to improve impressions",
      },
    },
  },
});
